import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { CustomerPlanItemCancelReasonDialogComponent } from '../customer-plan-item-cancel-reason-dialog/customer-plan-item-cancel-reason-dialog.component';

@Component({
  selector: 'app-customer-plan-item-edit-reason-dialog',
  templateUrl: './customer-plan-item-edit-reason-dialog.component.html',
  styleUrls: ['./customer-plan-item-edit-reason-dialog.component.sass']
})
export class CustomerPlanItemEditReasonDialogComponent implements OnInit {
  typeCes: TypeCesEnum;
  element: any = {};
  title = '';

  constructor(
    public toastService: ToastService,
    public dialogRef: MatDialogRef<CustomerPlanItemCancelReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      title: string;
      typeCes: TypeCesEnum;
      element: any;
    }
  ) {
    this.typeCes = data.typeCes;
    if (data?.title) this.title = data.title;
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }

  ngOnInit(): void {}

  public clickNo() {
    this.dialogRef.close(false);
  }

  public clickOk() {
    if (this.element?.updateReason)
      this.dialogRef.close({
        result: true,
        updateReason: this.element?.updateReason,
      });
    else this.toastService.showWarn('Informe o motivo da alteração.');
  }
}
